import { useId } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

const RADAR_PATH =
  'M20.07 4.93L18.66 6.34C20.1 7.79 21 9.79 21 12C21 16.42 17.42 20 13 20C8.58 20 5 16.42 5 12C5 7.92 8.05 4.56 12 4.07V6.09C9.16 6.57 7 9.03 7 12C7 15.31 9.69 18 13 18C16.31 18 19 15.31 19 12C19 10.34 18.33 8.84 17.24 7.76L15.83 9.17C16.55 9.9 17 10.9 17 12C17 14.21 15.21 16 13 16C10.79 16 9 14.21 9 12C9 10.14 10.28 8.59 12 8.14V10.28C11.4 10.63 11 11.26 11 12C11 13.1 11.9 14 13 14C14.1 14 15 13.1 15 12C15 11.26 14.6 10.62 14 10.28V2H13C7.48 2 3 6.48 3 12C3 17.52 7.48 22 13 22C18.52 22 23 17.52 23 12C23 9.24 21.88 6.74 20.07 4.93Z';
const PLAY_PATH = 'M4.5 15.5V21.5L9.5 18.5L4.5 15.5Z';

export const TimelinePlayIcon = (props: SvgIconProps): JSX.Element => {
  const id = useId();
  const radarMaskId = `${id}-radar`;
  const badgeMaskId = `${id}-badge`;

  return (
    <SvgIcon {...props} viewBox="0 0 25 25">
      <defs>
        <mask id={radarMaskId}>
          <rect width="25" height="25" fill="white" />
          <circle cx="6.5" cy="18.5" r="6.5" fill="black" />
        </mask>
        <mask id={badgeMaskId}>
          <rect width="25" height="25" fill="white" />
          <path d={PLAY_PATH} fill="black" />
        </mask>
      </defs>
      <path
        d={RADAR_PATH}
        fill="currentColor"
        fillOpacity={0.7}
        mask={`url(#${radarMaskId})`}
      />
      <circle
        cx="6.5"
        cy="18.5"
        r="5"
        fill="currentColor"
        mask={`url(#${badgeMaskId})`}
      />
    </SvgIcon>
  );
};
